import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

const LogFileTable = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [fileLogState, setFileLogState] = useState([]);

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setFileLogState(data)
    }, [data]);

    function resetlogfile() {
        const post_body = { serial: serial }
        updateTable(post_body, '/cmdresetlog', () => { })
        refreshlogfile()
    }

    function uploadlogfile() {
        const post_body = { serial: serial }
        updateTable(post_body, '/cmduploadlog', () => { })
    }

    function refreshlogfile() {
        mqttReq(serial, '/logmqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px' }}>
                {isOpen ? 'Nascondi LogFile' : 'Mostra LogFile'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle" colSpan="2">LOG</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <th className="title">File (MB)</th>
                            <th className="timetitle">Ultimo aggiornamento</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <td>{((fileLogState?.size / 1024) / 1024).toFixed(2)}</td>
                            <td>{fileLogState?.time}</td>
                            <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={refreshlogfile}>aggiorna</button>
                                <button onClick={resetlogfile}>X</button>
                                <button onClick={uploadlogfile}>carica su server</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default LogFileTable;
